import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserPasswordComponent } from './components/user-password/user-password.component';
const ɵ0 = {
    breadcrumb: 'Usuários',
    roles: 'A'
}, ɵ1 = {
    breadcrumb: 'Edição de Usuário',
    roles: 'A'
}, ɵ2 = {
    breadcrumb: 'Novo Usuário',
    roles: 'A'
}, ɵ3 = {
    breadcrumb: 'Troca de Senha',
};
const userRoutingModule = [
    {
        path: 'user/list',
        component: UserSearchComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    },
    {
        path: 'user/edit',
        component: UserDetailsComponent,
        canActivate: [AuthGuard],
        data: ɵ1
    },
    {
        path: 'user/add',
        component: UserDetailsComponent,
        canActivate: [AuthGuard],
        data: ɵ2
    },
    {
        path: 'user/pass',
        component: UserPasswordComponent,
        canActivate: [AuthGuard],
        data: ɵ3
    },
];
export class UserRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
